import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg-icon"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M22.001 12.2219C22.001 11.3997 21.9329 10.7997 21.7855 10.1775H12.2051V13.8885H17.8286C17.7153 14.8108 17.103 16.1997 15.7425 17.133L15.7234 17.2572L18.7525 19.5569L18.9624 19.5775C20.8898 17.833 22.001 15.2663 22.001 12.2219Z",
  fill: "#4285F4"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M12.2045 22.0001C14.9595 22.0001 17.2724 21.1111 18.9618 19.5778L15.7418 17.1333C14.8802 17.7222 13.7237 18.1333 12.2045 18.1333C9.5061 18.1333 7.21588 16.3889 6.39948 13.9778L6.27982 13.9877L3.13006 16.3767L3.08887 16.4889C4.76684 19.7555 8.21354 22.0001 12.2045 22.0001Z",
  fill: "#34A853"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  d: "M6.40001 13.9777C6.18459 13.3555 6.05993 12.6888 6.05993 12C6.05993 11.311 6.18459 10.6444 6.38868 10.0222L6.38297 9.88966L3.19373 7.4624L3.08938 7.51104C2.3978 8.86661 2.00098 10.3889 2.00098 12C2.00098 13.6111 2.3978 15.1332 3.08938 16.4888L6.40001 13.9777Z",
  fill: "#FBBC05"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("path", {
  d: "M12.2045 5.86663C14.1206 5.86663 15.4131 6.67773 16.1501 7.35556L19.0299 4.59999C17.2612 2.98889 14.9596 2 12.2045 2C8.21357 2 4.76685 4.24442 3.08887 7.51105L6.38817 10.0222C7.21591 7.61109 9.50614 5.86663 12.2045 5.86663Z",
  fill: "#EB4335"
}, null, -1)
const _hoisted_6 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4,
  _hoisted_5
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_6]))
}
export default { render: render }